<template>
  <div class="order-backlog">
    <div class="content">
      <div class="item mb_5">
        <span class="fw_500">购买商品</span>
        <span class="fw_500">{{ productName }}</span>
      </div>
      <div class="item spc_item bt">
        <span>绑定车辆</span>
        <span>{{ cpspOrderJson }}</span>
      </div>
      <div class="item spc_item mb_5">
        <span>车架号</span>
        <span>{{ orderInfo.vehicleVin }}</span>
      </div>
      <div class="item spc_item bt">
        <span>总价</span>
        <span>￥{{ twoDecimal(goodsPrice) }}</span>
      </div>
      <div class="item spc_item bt" @click="handleToCoupon">
        <span>优惠券</span>
        <span v-if="couponInfo.secondDiscountType == 1" class="coupon">
          ￥{{ twoDecimal(discountAmount) }}
          <img class="s_right" src="../../asset/img/s_right.png" />
        </span>
        <span v-if="couponInfo.secondDiscountType == 3" class="coupon">
          {{ couponInfo.discountRate | toRateNum }}折
          <img class="s_right" src="../../asset/img/s_right.png" />
        </span>
      </div>
      <div class="item spc_item mb_5">
        <span>支付金额</span>
        <span>￥{{ twoDecimal(payPrice) }}</span>
      </div>
    </div>
    <div class="bottom">
      <a href="javascript:;" @click="handleToOrder">下单并支付</a>
    </div>
  </div>
</template>
<script>
import {
  addServiceRenewal,
  optimalPrice
} from "../../helper/api/service-renewal";
import { SUCCESS_CODE } from "../../utils/config";
import { mapState } from "vuex";
export default {
  data() {
    return {
      goodsPrice: 0,
      orderInfo: {},
      flag: false
    };
  },
  computed: {
    ...mapState({
      discountAmount: state =>
        state.newServiceRenewal.couponInfo.discountAmount || 0,
      childId: state => state.newServiceRenewal.couponInfo.childId || "",
      couponInfo: state => state.newServiceRenewal.couponInfo || {}
    }),
    payPrice() {
      // eslint-disable-next-line eqeqeq
      if (this.couponInfo.secondDiscountType == 1) {
        return this.goodsPrice - this.discountAmount < 0
          ? 0
          : this.goodsPrice - this.discountAmount;
      }
      const discountRate = this.couponInfo.discountRate
        ? this.couponInfo.discountRate
        : 100;
      return (this.goodsPrice * discountRate) / 100;
    },
    twoDecimal() {
      return function(val) {
        try {
          return (val / 100).toFixed(2);
        } catch (err) {
          return 0;
        }
      };
    },
    cpspOrderJson() {
      return ((this.orderInfo.orderItemList || [])[0] || {}).cpspOrderJson;
    },
    productName() {
      const productInfo = (this.orderInfo.orderItemList || [])[0] ?? {};
      return productInfo.productName ?? "--";
    }
  },
  created() {
    this.$bridge.call("Controller.refreshNav", {
      fullScreen: false,
      title: "订单确认"
    });
  },
  // eslint-disable-next-line vue/order-in-components
  filters: {
    toRateNum(num) {
      let rate = typeof num === "number" ? num : Number(num);
      rate = (rate / 100) * 10;
      return rate;
    }
  },
  mounted() {
    const serviceRenewalInfo = this.$bridge.call("Storage.serviceRenewalInfo");
    if (!serviceRenewalInfo) {
      this.$toast("获取APP信息失败~~");
      return;
    }
    const {
      // eslint-disable-next-line no-unused-vars
      ssoId,
      // eslint-disable-next-line no-unused-vars
      tokenId,
      // eslint-disable-next-line no-unused-vars
      cVer,
      accessToken,
      brand,
      terminal,
      rs,
      // eslint-disable-next-line no-unused-vars
      avatar,
      // eslint-disable-next-line no-unused-vars
      username,
      phone,
      enterpriseId
    } = serviceRenewalInfo || {};
    this.headers = {
      brand,
      terminal,
      accessToken,
      rs,
      enterpriseId,
      phoneNum: phone
    };
    this.orderInfo =
      this.$store.state.newServiceRenewal.orderInfo ||
      JSON.parse(localStorage.getItem("carWashOrder"));
    this.goodsPrice = this.orderInfo.totalAmount;
    // 判断是否从其他页面进入的,是的话不能调用最优优惠券接口, 从 vuex 取数据
    if (this.$route.query.sourceType !== "coupon") {
      this.optimalPrice();
    }
  },
  methods: {
    // 生成订单
    handleToOrder() {
      if (this.flag) {
        this.$toast("订单生成中");
        return;
      }
      this.flag = true;
      const params = {
        ...this.orderInfo,
        couponId: this.childId
      };
      addServiceRenewal(params, { ...this.headers })
        .then(res => {
          const data = res.data || {};
          this.flag = false;
          if (data.code === SUCCESS_CODE) {
            const { orderNo, orderStatus, payOrderNo, sign, payUrl } =
              (data.data || [])[0] || {};
            // 排除orderNo orderStatus payOrderNo sign为空的情况, payUrl包含订单信息,服务端返回
            if (orderStatus === "ORDER_COMP") {
              // 0 元单
              this.$router.push("/new-service-renewal/success");
              return;
            }
            if (orderNo && orderStatus && payOrderNo && sign) {
              // 支付成功后跳转页面
              const backUrl = `${window.location.origin}/app-h5-dashboard-haval/new-service-renewal/success`;
              // 支付页header返回页面
              const appBackUrl = `${window.location.origin}/app-h5-dashboard-haval/new-service-renewal/serviceOrder/${orderNo}`;
              // 支付服务
              const jumpUrl = `${payUrl}&cashierStyle=0001&createTime=${new Date().getTime()}&appBackUrl=${encodeURIComponent(
                encodeURIComponent(appBackUrl)
              )}&backUrl=${encodeURIComponent(encodeURIComponent(backUrl))}`;
              window.location.href = jumpUrl;
            } else {
              this.$toast("订单信息存在缺失, 请联系客服~~");
            }
          } else {
            this.$toast(data.description);
          }
        })
        .catch(err => {
          this.$toast(err);
          this.flag = false;
        });
    },
    // 选择优惠券
    handleToCoupon() {
      this.$router.replace({
        path: "/new-service-renewal/discountCoupon"
      });
    },
    // 优惠券
    optimalPrice() {
      const skuList = this.getSkuInfo();
      const params = {
        calculateType: "OPTIMAL_CALCULATE", // 计算类型 OPTIMAL_CALCULATE：计算最优CONSULTATION_CALCULATE：咨询计算（根据传入的优惠计算价格）
        skuList
      };
      optimalPrice(params, this.headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) {
          // 是否有最优优惠券
          const list = data.data.bestCoupon || [];
          if (list.length) {
            const mapOptimal = data.data.bestCoupon[0] || {};
            this.$store.commit("setCouponInfo", {
              discountAmount: mapOptimal.discountAmount ?? 0, // 商品优惠金额（总优惠金额）
              childId: mapOptimal.childId,
              secondDiscountType: mapOptimal.secondDiscountType,
              discountRate: mapOptimal.discountRate ?? 0
            });
          } else {
            // 不存在优惠券
            this.$store.commit("setCouponInfo", {
              discountAmount: 0,
              childId: "",
              secondDiscountType: 1,
              discountRate: 0
            });
          }
        }
      });
    },
    // 获取 skuInfo
    getSkuInfo() {
      const {
        orderItemList: [{ productSkuId, productPrice, productCategoryId }]
      } = this.orderInfo;
      return [
        {
          categoryId: productCategoryId, // 类目id
          goodsNum: 1, // 商品数量
          goodsPrice: productPrice, // 商品价格
          skuId: productSkuId
        }
      ]; // 商品id
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../asset/scss/mixin.scss";
.order-backlog {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
  .coupon {
    position: relative;
    padding-right: pxTorem(20);
    .s_right {
      width: pxTorem(20);
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .fw_500 {
    font-weight: bold;
  }
  .content {
    background: #f5f5f5;
    .item {
      width: 100%;
      height: pxTorem(61);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      font-size: pxTorem(16);
      color: #656566;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: pxTorem(15);
      padding-right: pxTorem(15);
      background: #fff;
      .copy {
        width: pxTorem(20);
        height: pxTorem(14);
        font-size: pxTorem(10);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #696d77;
        line-height: pxTorem(14);
        background: #ececec;
        border-radius: pxTorem(10);
        padding: 0 pxTorem(7);
      }
    }
    .spc_item {
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: pxTorem(14);
      color: #696d77;
      height: pxTorem(56);
      margin-bottom: pxTorem(0);
      background: #fff;
    }
    .mb_5 {
      margin-bottom: pxTorem(5);
    }
    .bt {
      border-bottom: pxTorem(1) solid #eee;
    }
  }
  .bottom {
    width: 100%;
    height: pxTorem(85);
    background: #ffffff;
    padding: 0 pxTorem(20);
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    a {
      width: 100%;
      line-height: pxTorem(41);
      border-radius: pxTorem(30);
      border: pxTorem(2) solid #2d2d2d;
      text-align: center;
      color: #fff;
      background: #2d2d2d;
    }
  }
}
</style>
